<aside class="w-64 bg-slate-950 text-white flex-col hidden md:flex md:h-screen">
  <div class="p-8 border-b border-white/5">
    <h1 class="text-2xl font-black tracking-tighter text-indigo-500">
      EVNT<span class="text-white font-light ml-1">CRM</span>
    </h1>
    <p class="text-[10px] text-slate-600 mt-2 uppercase font-black tracking-widest">
      Hospitality Demo Mode
    </p>
  </div>

  <!-- TODO: Lista de espera será desenvolvido em outro momento -->
  <!-- <div class="px-6 py-6">
    <button
      type="button"
      (click)="handleWaitlistRequest()"
      [disabled]="waitlistStatus() === 'success'"
      [class]="
        waitlistStatus() === 'success'
          ? 'w-full p-4 rounded-2xl flex flex-col gap-2 transition-all group shadow-lg relative overflow-hidden border bg-emerald-600 border-emerald-500'
          : 'w-full p-4 rounded-2xl flex flex-col gap-2 transition-all group shadow-lg relative overflow-hidden border bg-indigo-600 hover:bg-indigo-500 border-indigo-500/20'
      "
      aria-label="Garantir vaga na lista de espera"
    >
      <div
        class="absolute -right-4 -top-4 w-12 h-12 bg-white/10 rounded-full group-hover:scale-150 transition-transform"
      ></div>
      <div class="flex items-center gap-2">
        @if (waitlistStatus() === 'success') {
          <lucide-icon [img]="icons.check" class="w-4 h-4 text-white" />
        } @else {
          <lucide-icon [img]="icons.sparkles" class="w-4 h-4 text-white animate-pulse" />
        }
        <span class="text-[10px] font-black uppercase tracking-widest text-white">
          {{ waitlistStatus() === 'success' ? 'Solicitado!' : 'Garantir Vaga' }}
        </span>
      </div>
      <p class="text-[9px] text-indigo-100 font-medium text-left leading-tight">
        {{
          waitlistStatus() === 'success'
            ? 'Fila de prioridade confirmada.'
            : 'Saia da demo e entre para o time oficial EVNT.'
        }}
      </p>
      <div
        class="flex items-center gap-1 mt-1 text-[9px] font-black text-white uppercase tracking-widest"
      >
        {{ waitlistStatus() === 'success' ? 'Em processamento...' : 'Entrar na fila' }}
        <lucide-icon
          [img]="icons.chevronRight"
          class="w-3 h-3 group-hover:translate-x-1 transition-transform"
        />
      </div>
    </button>
  </div> -->

  <div class="px-6 mt-5 pb-6 border-b border-white/5">
    <label class="block text-[10px] uppercase font-black text-slate-600 mb-3 tracking-widest">
      Acesso de Experimento
    </label>
    <div class="flex bg-slate-900 rounded-xl p-1 border border-white/5">
      <button
        type="button"
        (click)="setRole('executive')"
        [class]="
          role() === 'executive'
            ? 'flex-1 flex items-center justify-center gap-2 py-2 text-[10px] font-black uppercase rounded-lg transition-all bg-indigo-600 text-white shadow-lg cursor-pointer'
            : 'flex-1 flex items-center justify-center gap-2 py-2 text-[10px] font-black uppercase rounded-lg transition-all text-slate-500 hover:text-white cursor-pointer'
        "
        aria-label="Alternar para perfil executivo"
      >
        <lucide-icon [img]="icons.user" class="w-3.5 h-3.5" /> Exec
      </button>
      <button
        type="button"
        (click)="setRole('manager')"
        [class]="
          role() === 'manager'
            ? 'flex-1 flex items-center justify-center gap-2 py-2 text-[10px] font-black uppercase rounded-lg transition-all bg-indigo-600 text-white shadow-lg cursor-pointer'
            : 'flex-1 flex items-center justify-center gap-2 py-2 text-[10px] font-black uppercase rounded-lg transition-all text-slate-500 hover:text-white cursor-pointer'
        "
        aria-label="Alternar para perfil gestor"
      >
        <lucide-icon [img]="icons.userCog" class="w-3.5 h-3.5" /> Gestor
      </button>
    </div>
  </div>

  <div class="px-6 py-6 border-b border-white/5 bg-slate-900/40">
    <div class="flex items-center gap-4">
      <div
        class="w-10 h-10 rounded-2xl bg-indigo-500/10 flex items-center justify-center text-indigo-500 font-black border border-indigo-500/20 shadow-inner"
      >
        {{ currentUser().name.charAt(0) }}
      </div>
      <div class="overflow-hidden">
        <p class="text-xs font-black text-slate-100 truncate uppercase tracking-tight">
          {{ currentUser().name }}
        </p>
        <p class="text-[10px] text-slate-500 font-bold truncate flex items-center gap-1 mt-0.5">
          <lucide-icon [img]="icons.briefcase" class="w-3 h-3" />
          {{ role() === 'manager' ? 'Administrador' : 'Executivo EVNT' }}
        </p>
      </div>
    </div>
  </div>

  <nav class="flex-1 p-6 space-y-1 overflow-auto">
    <button
      type="button"
      (click)="navigate('dashboard')"
      [class]="
        activeView() === 'dashboard'
          ? 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all bg-indigo-600 text-white shadow-xl shadow-indigo-600/20 cursor-pointer'
          : 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all text-slate-400 hover:bg-white/5 hover:text-white cursor-pointer'
      "
    >
      <lucide-icon [img]="icons.layoutDashboard" class="w-5 h-5" /> Dashboard
    </button>

    <button
      type="button"
      (click)="navigate('wallet')"
      [class]="
        activeView() === 'wallet'
          ? 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all bg-indigo-600 text-white shadow-xl shadow-indigo-600/20 cursor-pointer'
          : 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all text-slate-400 hover:bg-white/5 hover:text-white cursor-pointer'
      "
    >
      <lucide-icon [img]="icons.users" class="w-5 h-5" />
      {{ role() === 'manager' ? 'Carteira Global' : 'Minha Carteira' }}
    </button>

    <button
      type="button"
      (click)="navigate('calendar')"
      [class]="
        activeView() === 'calendar'
          ? 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all bg-indigo-600 text-white shadow-xl shadow-indigo-600/20 cursor-pointer'
          : 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all text-slate-400 hover:bg-white/5 hover:text-white cursor-pointer'
      "
    >
      <lucide-icon [img]="icons.calendar" class="w-5 h-5" /> Agenda
    </button>

    <button
      type="button"
      (click)="navigate('reports')"
      [class]="
        activeView() === 'reports'
          ? 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all bg-indigo-600 text-white shadow-xl shadow-indigo-600/20 cursor-pointer'
          : 'w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all text-slate-400 hover:bg-white/5 hover:text-white cursor-pointer'
      "
    >
      <lucide-icon [img]="icons.fileBarChart" class="w-5 h-5" /> Relatórios
    </button>

    <!-- TODO: Funil de vendas será desenvolvido em outro momento -->
    <!-- <button
      type="button"
      class="w-full flex items-center gap-4 px-4 py-3.5 rounded-xl text-[11px] font-black uppercase tracking-widest transition-all text-slate-600 cursor-not-allowed"
      aria-disabled="true"
    >
      <lucide-icon [img]="icons.filter" class="w-5 h-5" /> Funil Vendas
    </button> -->
  </nav>

  <div class="p-6 border-t border-white/5 space-y-3">
    <button
      type="button"
      (click)="navigate('setup')"
      [class]="
        activeView() === 'setup'
          ? 'w-full flex items-center gap-3 px-4 py-2 text-[10px] font-black uppercase tracking-widest transition-all text-white cursor-pointer'
          : 'w-full flex items-center gap-3 px-4 py-2 text-[10px] font-black uppercase tracking-widest transition-all text-slate-500 hover:text-white cursor-pointer'
      "
    >
      <lucide-icon [img]="icons.settings" class="w-4 h-4" /> Configurações
    </button>
    <button
      type="button"
      (click)="handleLogout()"
      class="w-full flex items-center gap-3 px-4 py-2 text-rose-500/70 hover:text-rose-400 text-[10px] font-black uppercase tracking-widest transition-all cursor-pointer"
    >
      <lucide-icon [img]="icons.logOut" class="w-4 h-4" /> Finalizar Demo
    </button>
  </div>
</aside>
